// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type ClockIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from clock.svg
 */
export default function ClockIcon(props: ClockIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="ClockIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M8 0c4.052 0 8 3.948 8 8s-3.948 8-8 8-8-3.948-8-8 3.948-8 8-8m0 2C5.052 2 2 5.052 2 8s3.052 6 6 6 6-3.052 6-6-3.052-6-6-6"
        />
        <path
          fill="currentColor"
          d="M8 3a1 1 0 0 1 1 1v3.465l2.555 1.703a1 1 0 0 1-1.11 1.664l-3-2A1 1 0 0 1 7 8V4a1 1 0 0 1 1-1"
        />
      </g>
    </svg>
  );
}
